const CallToActionArrows = ({ backgroundColor, gridColor, shapeColor }) => {
  return (
    <svg viewBox="0 0 1920 320" fill="none">
      <rect
        x="-1440"
        y="-320"
        width="4320"
        height="960"
        fill="url(#grid-pattern-cta)"
      />
      <g transform="translate(-1, -1)">
        <g opacity="0.25">
          <path
            d="M696 0L840 144V176L696 320H-529L-673 176V144L-529 0H696Z"
            fill={shapeColor}
            stroke={shapeColor}
            strokeWidth="1.5"
          />
        </g>
        <path
          d="M856 0L1000 144V176L856 320H-369L-513 176V144L-369 0H856Z"
          stroke={shapeColor}
          strokeWidth="1.5"
        />

        <path
          d="M776 0L920 144V176L776 320H-449L-593 176V144L-449 0H776Z"
          stroke={shapeColor}
          strokeWidth="1.5"
          strokeDasharray="3"
        />
      </g>
      <defs>
        <pattern
          id="grid-pattern-cta"
          viewBox="0 0 40 40"
          width="0.925925926%"
          height="4.16666667%"
        >
          <rect width="40" height="40" fill={backgroundColor} />
          <line
            x1="39"
            y1="0"
            x2="39"
            y2="39"
            stroke={gridColor}
            strokeDasharray="2 2"
            strokeOpacity="0.5"
          />
          <line
            x1="0"
            y1="39"
            x2="39"
            y2="39"
            stroke={gridColor}
            strokeDasharray="2 2"
            strokeOpacity="0.5"
          />
        </pattern>
      </defs>
    </svg>
  );
};

export const CallToActionArrowsPurple = () => (
  <CallToActionArrows
    shapeColor="var(--brand-color-purple-5)"
    backgroundColor="var(--brand-color-purple-7)"
    gridColor="var(--brand-color-purple-6)"
  />
);

export const CallToActionArrowsRed = () => (
  <CallToActionArrows
    shapeColor="var(--brand-color-red-5)"
    backgroundColor="var(--brand-color-red-7)"
    gridColor="var(--brand-color-red-6)"
  />
);

export const CallToActionArrowsGreen = () => (
  <CallToActionArrows
    shapeColor="var(--brand-color-green-3)"
    backgroundColor="var(--brand-color-green-2)"
    gridColor="var(--brand-color-green-3)"
  />
);
